import axiosInstance from "../api/apiClient";

//user routes
const getReportsByUser = async (page) => {
  try {
    const { data } = await axiosInstance.get(
      `/reports/user/results?page=${page}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

const getReportsById = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/reports/user/results/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

const deleteReport = async (id) => {

  try {
    const { data } = await axiosInstance.delete(`/reports/${id}`);
    return data;
  } catch (err) {
    throw err;
  }
};

const emailReport = async (id) => {

  try {
    const { data } = await axiosInstance.post(`/reports/email/${id}`);
    return data;
  } catch (err) {
    throw err;
  }
};



const getAllReports = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/reports`);
    return data;
  } catch (err) {
    throw err;
  }
};
export { getReportsByUser, getReportsById, deleteReport,emailReport,getAllReports };
